import { Routes, Route, BrowserRouter, Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import Index from "./pages/Index.jsx";
import Admin from "./pages/Admin.jsx";
import ContactUs from "./pages/ContactUs.jsx";
import PartyGear from "./pages/PartyGear.jsx";
import Health from "./pages/Health.jsx";
import Login from "./pages/Login.jsx";
import ProtectedRoute from "./ProtectedRoute.jsx";
import Header from "./ui/Header.jsx";
import SignupPage from "./pages/SignupPage.jsx";
import {QueryClientProvider} from "@tanstack/react-query";
import { queryClient } from "./services/reactQueryClient";
import Privacy from "./pages/Privacy.jsx";
import Terms from "./pages/Terms.jsx";
import AdvertisingDisclosure from "./pages/AdvertisingDisclosure.jsx";
import CookieBanner from "./ui/CookieBanner.jsx";
import Roadmap from "./pages/Roadmap.jsx";
import Footer from "./ui/Footer.jsx";
import EventDetails from "./pages/EventDetails.jsx";
import NotFound from "./pages/NotFound.jsx";

function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
        // Track page views on route changes (SPA)
        window.gtag?.("event", "page_view", {
            page_path: location.pathname + location.search,
        });
    }, [location]);

    return null;
}

function HeaderWithRouteFilters(props) {
    const { pathname } = useLocation();

    // routes where filters should be hidden
    const hideFilters = [
        "/contact-us",
        "/privacy",
        "/health-and-safety",
        "/terms",
        "/advertising-disclosure",
        "/roadmap",
    ].includes(pathname);

    return <Header {...props} showLocationFilters={!hideFilters} />;
}

function App() {
    const [selectedCountry, setSelectedCountry] = useState("Australia");
    const [selectedCity, setSelectedCity] = useState("Melbourne");
    
    return (
        
        <QueryClientProvider client = {queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
            
        <BrowserRouter>
            <AnalyticsTracker />
            <HeaderWithRouteFilters
                selectedCountry={selectedCountry}
                setSelectedCountry={setSelectedCountry}
                selectedCity={selectedCity}
                setSelectedCity={setSelectedCity}
            />
            {/* Wrapper with Full-Screen Fixed Background */}
            <div>
                {/* Background Layer */}
                <div
                    className="fixed top-0 left-0 w-full h-full bg-cover bg-center z-[-1]"
                    style={{
                        // background: `linear-gradient(to bottom right, #262768FF, #B77AB4FF)`,
                        //backgroundImage: `url("/images/openart-image_RE5cUP74_1736508954943_raw.jpg")`,
                        willChange: "transform",
                        transform: "translate3d(0, 0, 0)"
                    }}
                />

                {/* Routing Section */}
                <Routes>
                    <Route path="/events/:eventId" element={<EventDetails />} />
                    <Route path="*" element={<NotFound />} />
                    <Route 
                        element={
                        <ProtectedRoute requiredRole="admin">
                        <Outlet/>
                        </ProtectedRoute>}
                    >
                        <Route
                            path="admin"
                            element={<Admin />}
                        />
                    </Route>
                    
                    <Route
                        path="/"
                        element={
                            <Index
                                selectedCountry={selectedCountry}
                                setSelectedCountry={setSelectedCountry}
                                selectedCity={selectedCity}
                                setSelectedCity={setSelectedCity}
                            />
                        }
                    />
                    
                    <Route
                        path="/login"
                        element={
                            <Login/>
                        }
                    />

                    <Route
                        path="/register"
                        element={
                            <div className="relative flex flex-col items-center 
                            justify-center min-h-screen bg-opacity-80">
                                <div className="bg-transparent bg-opacity-80 p-6 
                                rounded-lg w-full max-w-4xl flex flex-col items-center">
                                    <SignupPage/>
                                </div>
                            </div>
                        }
                    />

                    <Route
                        path="/contact-us"
                        element={
                            <ContactUs/>
                        }
                    />

                    <Route
                        path="/roadmap"
                        element={
                            <Roadmap/>
                        }
                    />

                    <Route
                        path="/queer-retail"
                        element={
                            <PartyGear
                                selectedCountry={selectedCountry}
                                setSelectedCountry={setSelectedCountry}
                                selectedCity={selectedCity}
                                setSelectedCity={setSelectedCity}
                            />
                        }
                    />

                    <Route
                        path="/health-and-safety"
                        element={
                            <Health/>
                        }
                    />

                    <Route
                        path="/privacy"
                        element={
                            <Privacy/>
                        }
                    />

                    <Route
                        path="/terms"
                        element={
                            <Terms/>
                        }
                    />

                    <Route
                        path="/advertising-disclosure"
                        element={
                            <AdvertisingDisclosure/>
                        }
                    />

                </Routes>
            </div>
            
            <Footer />
            <CookieBanner />
        </BrowserRouter>


        </QueryClientProvider>



);
}

export default App;
